import { createSlice } from '@reduxjs/toolkit';
const initialState = () => {
    return {
        roles:[],
        userAddStatus:null,
        userDetails:[],
        userErrors:[],
    };
  };

const userSlice = createSlice({
  name: 'user',
  initialState:initialState(),
  reducers: {
    setRoles(state, action) {
      state.roles = action.payload;
    },
    setuserErrors(state, action) {
      state.userErrors = action.payload;
    },
    setUserAddStatus(state, action) {
      state.userAddStatus = action.payload;
    },
    setUserDetails(state, action) {
        state.userDetails= action.payload;
      },
  },
});

export const {
  setRoles,
  setuserErrors,
  setUserAddStatus,
  setUserDetails
  
} = userSlice.actions;
export const user=userSlice.reducer;